/**
 * @file   : Padder.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 2/11/2019, 3:24:02 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'

export const PAD_0 = 0
export const PAD_10 = 10
export const PAD_20 = 20

// eslint-disable-next-line one-var
const Padder = ({
  padTop = PAD_0,
  padBottom = PAD_0,
  padLeft = PAD_0,
  padRight = PAD_0,
  children,
}) => {
  const getClassName = function () {
    let className = ''
    if (padTop !== PAD_0) {
      className += ` padder-pad-top${padTop.toString()}`
    }

    if (padBottom !== PAD_0) {
      className += ` padder-pad-bottom-${padBottom.toString()}`
    }

    if (padLeft !== PAD_0) {
      className += ` padder-pad-left-${padLeft.toString()}`
    }

    if (padRight !== PAD_0) {
      className += ` padder-pad-right-${padRight.toString()}`
    }

    return className
  }

  return <Cont className={getClassName()}>{children}</Cont>
}

Padder.propTypes = {
  padTop: PropTypes.oneOf([PAD_0, PAD_10, PAD_20]),
  padBottom: PropTypes.oneOf([PAD_0, PAD_10, PAD_20]),
  padLeft: PropTypes.oneOf([PAD_0, PAD_10, PAD_20]),
  padRight: PropTypes.oneOf([PAD_0, PAD_10, PAD_20]),
  children: PropTypes.node,
}

export default Padder
